export default "__VITE_PUBLIC_ASSET__4282ce13__"